export default "__VITE_ASSET__NA8x36ET__"